import { createError, uuidSchema } from '@common/neo.tax';
import { useParams } from 'react-router-dom';

export const useSelectedFiscalYearIdOptional = (): string | null => {
  const { fiscalYearId } = useParams();
  if (!fiscalYearId) {
    return null;
  }
  const { data, success } = uuidSchema.safeParse(fiscalYearId);
  if (!success) {
    return null;
  }
  return data;
};

export const useSelectedFiscalYearId = (): string => {
  const fiscalYearId = useSelectedFiscalYearIdOptional();
  if (!fiscalYearId) {
    throw createError('MissingFiscalYearId', 'No valid fiscal year id in the route');
  }
  return fiscalYearId;
};
